import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {KFConfiguration} from '../../../../kf-data-entry/models/kf-configuration.interface';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatSort} from '@angular/material/sort';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {PageEvent} from '@angular/material/paginator';
import {ConfirmDialogComponent} from '../../../../shared/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-kf-configuration-admin-table',
  templateUrl: './kf-configuration-admin-table.component.html',
  styleUrls: ['./kf-configuration-admin-table.component.scss']
})
export class KfConfigurationAdminTableComponent implements AfterViewInit {
  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['year', 'level', 'entry', 'unuKeySetName', 'kfCategorySetName', 'collectionStreamName', 'launched', 'open', 'actions'];

  @Input()
  kfConfigurations!: KFConfiguration[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadKfConfigurations: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();

  @Output()
  reopenConfiguration: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  printKfConfiguration: EventEmitter<KFConfiguration> = new EventEmitter<KFConfiguration>();

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly router: Router,
              private readonly dialog: MatDialog) {
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadKfConfigurations.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadKfConfigurations.emit({page: event.pageIndex, size: event.pageSize});
  }

  reopen(kfConfig: KFConfiguration): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        item: 'kf-reporting.reopen'
      },
      maxWidth: 600
    });
    dialogRef.componentInstance.confirmEvent.subscribe(() => {
      this.reopenConfiguration.emit(kfConfig.reportCycleReferenceId);
      dialogRef.close();
    });
  }

  capitalize(text: string): string {
    return text.charAt(0).toUpperCase() + text.toLowerCase().slice(1);
  }


  print(kfConfig: KFConfiguration): void {
    this.printKfConfiguration.emit(kfConfig);
  }
}
